import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const DataTableInput = (props) => {
    const [value, setvalue] = useState(props.value);

    const onChange = (e) => {
        const value = e.target.value;
        if (props.inputAcceptType === "number") {
            if (/^-?\d*$/.test(value)) setvalue(value);
        }
        else {
            setvalue(value);
        }
    }

    useEffect(() => {
        setvalue(props.value)
    }, [props.value])

    return <div onClick={props.onClick} disabled={props.disabled} className={styles.inputElement}>{props.rows ?
        <textarea
            value={value||''}
            placeholder={props.placeholder}
            onChange={onChange}
            readOnly={props.readOnly}
            id={props.elementId}
            type={props.type}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            rows={props.rows}
            ref={props.elementRef}
            disabled={props.disabled}
            onKeyDown={props.onKeyDown}
            style={props.style}
        />
        : <input
            value={value||''}
            placeholder={props.placeholder}
            onChange={onChange}
            readOnly={props.readOnly}
            id={props.elementId}
            type={props.inputElementType}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            ref={props.elementRef}
            disabled={props.disabled}
            onKeyDown={props.onKeyDown}
            style={props.style}
        />}
        {props.loading ? <div className={styles.iconContainer}><i className={styles.loader}></i></div> : ''}
    </div>
}

DataTableInput.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    placeholder: PropTypes.string,
    elementId: PropTypes.string,
    inputElementType: PropTypes.string,
    inputAcceptType: PropTypes.string,
    rows: PropTypes.string,
    loading: PropTypes.bool,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func
};

DataTableInput.defaultProps = {
    value: '',
    loading: false
};

export default DataTableInput;


// WEBPACK FOOTER //
// ./src/components/Input/input.js